import * as Sentry from "@sentry/react";
import { Alert, Button } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { ReactNode } from "react";

/**
 * Sentry marks an error caught here as handled, because it keys that off the
 * presence of a fallback.
 */
export const PanelErrorBoundary = ({
  panel,
  children,
}: {
  panel: string;
  children: ReactNode;
}) => {
  const { t } = useTenantTranslation();

  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag("panel", panel);
      }}
      onError={(error, componentStack) => {
        console.error(`PanelErrorBoundary (${panel}) caught:`, error);
        console.error("Component stack:", componentStack);
      }}
      fallback={(fallbackProps) => (
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          action={
            <Button
              size="small"
              color="inherit"
              onClick={() => {
                fallbackProps.resetError();
              }}
            >
              {t("retry")}
            </Button>
          }
        >
          {t("globalErrorTitle")}
        </Alert>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
